<script>
import { useLayoutStore } from "~/stores/layout";
import { LAYOUT_TYPE } from "~/app/const";
import Vertical from "~/components/leyoutsCustomer/vertical/index.vue";
import Horizontal from "~/components/leyoutsCustomer/horizontal/index.vue";

export default {
  data() {
    return {
      LAYOUT_TYPE
    };
  },
  created() {
    if (process.client) {
         document.body.removeAttribute("data-layout");
   document.body.removeAttribute("data-topbar");
   document.body.removeAttribute("data-layout");
    document.body.setAttribute("data-layout", "vertical");
        }  
   
  },
  components: {
    Vertical,
    Horizontal
  },
  computed: {
    layoutType() {
      return useLayoutStore() ? useLayoutStore().layoutType : {};
    },
    isVertical() {
      return this.layoutType === LAYOUT_TYPE.VERTICAL;
    },
    isHorizontal() {
      return this.layoutType === LAYOUT_TYPE.HORIZONTAL;
    }
  },
  mounted() {
   // document.body.classList.remove("authentication-bg");
  }
};
</script>

<template>
  <div>
    <ClientOnly>
      <Vertical >
        <slot />
      </Vertical>
     
    </ClientOnly>
  </div>
</template>
